'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var localStore = require('./localStore.js');
var shuffle = require('lodash/shuffle');
require('./tslib.es6-f8b34207.js');
require('./memoryStorage.js');
require('./_storageService-fcdc54f2.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var shuffle__default = /*#__PURE__*/_interopDefaultLegacy(shuffle);

var SecondLocation = /** @class */ (function () {
    function SecondLocation() {
        // private enabled: boolean = false;
        this.defaultScreenType = 'ss';
        this.defaultPlatform = 'web';
        this.defaultEnv = 'prod';
        this.maxAttempts = 4;
        this.failedDomains = {};
        this.backends = {
            prod: {
                bs: {
                    stv: {
                        sila: 'bs-app-sila.ais-vidnt.com',
                        tls: 'bs-app-tls.ais-vidnt.com',
                    },
                },
                ss: {
                    web: {
                        sila: 'web-sila.ais-vidnt.com',
                        tls: 'web-tls.ais-vidnt.com',
                    },
                    // stv: {
                    //     sila: 'ss-app-sila.ais-vidnt.com',
                    //     tls: 'ss-app-tls.ais-vidnt.com',
                    // }
                },
            },
            stg: {
                bs: {
                    stv: {
                        sila: 'bs-app-stg-sila.demo-vidnt.com',
                        tls: 'bs-app-stg-tls.demo-vidnt.com',
                    },
                },
                ss: {
                    web: {
                        sila: 'ss-app-stg-sila.demo-vidnt.com',
                        tls: 'ss-app-stg-tls.demo-vidnt.com',
                    },
                },
            },
            qa: {
                bs: {
                    stv: {
                        demo: 'ais-qa-app.demo-vidnt.com',
                    },
                },
                ss: {
                    web: {
                        demo: 'ais-qa-app.demo-vidnt.com',
                    },
                },
            },
            dev: {
                bs: {
                    stv: {
                        trk: 'dev-trk.vidnt.com',
                    },
                },
                ss: {
                    web: {
                        trk: 'dev-trk.vidnt.com',
                    },
                },
            },
        };
    }
    SecondLocation.prototype.enable = function () {
        localStore.localStore.set('2nd', true);
    };
    SecondLocation.prototype.disable = function () {
        localStore.localStore.delete('2nd');
        localStore.localStore.delete('2nd_st');
        localStore.localStore.delete('2nd_env');
        localStore.localStore.delete('2nd_ab');
    };
    SecondLocation.prototype.isEnabled = function () {
        return localStore.localStore.get('2nd');
    };
    SecondLocation.prototype.setMaxAttempts = function (attempts) {
        if (attempts === void 0) { attempts = null; }
        if (attempts) {
            this.maxAttempts = attempts;
        }
    };
    SecondLocation.prototype.setScreenType = function (type) {
        if (!type)
            return;
        localStore.localStore.set('2nd_st', type);
    };
    SecondLocation.prototype.setPlatform = function (platform) {
        if (!platform)
            return;
        localStore.localStore.set('2nd_pf', platform);
    };
    SecondLocation.prototype.setEnv = function (env) {
        if (env === void 0) { env = 'prod'; }
        // this.env = env;
        if (!env)
            return;
        localStore.localStore.set('2nd_env', env);
    };
    Object.defineProperty(SecondLocation.prototype, "env", {
        get: function () {
            return localStore.localStore.get('2nd_env') || this.defaultEnv;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SecondLocation.prototype, "screenType", {
        get: function () {
            return localStore.localStore.get('2nd_st') || this.defaultScreenType;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SecondLocation.prototype, "platform", {
        get: function () {
            return localStore.localStore.get('2nd_pf') || this.defaultPlatform;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * @description to get current backend domain
     * @return string
     * */
    SecondLocation.prototype.getBackDomain = function () {
        if (!localStore.localStore.get('2nd_ab')) {
            var list = this.backends[this.env][this.screenType][this.platform];
            var randArray = shuffle__default["default"](Object.values(list));
            var domain = randArray[0];
            // if (domain === 'current') {
            //     domain = location.host;
            // }
            localStore.localStore.set('2nd_ab', domain);
        }
        return localStore.localStore.get('2nd_ab');
    };
    /**
     * @description to reset backend state */
    SecondLocation.prototype.backToLive = function (domain) {
        if (this.failedDomains[domain]) {
            delete this.failedDomains[domain];
            return true;
        }
        return false;
    };
    /**
     * @param domain {String} domain which failed
     * @param httpCode {Number} http code of response
     * @param cacheState {Boolean} false - if no cache for the request, true - if record in the cache
     * @description to notify the module that some request filed
     * @return {string} status:
     * true - try again with calling getBackDomain;
     * null - try use response from cache,
     * false - handle the failed request as final error
     * number - (seconds) handle the same query with delay - the number of seconds
     * */
    SecondLocation.prototype.onBackendFailed = function (domain, httpCode, cacheState) {
        var _this = this;
        if (httpCode === void 0) { httpCode = null; }
        if (cacheState === void 0) { cacheState = null; }
        var status;
        if (httpCode && httpCode === 429) {
            if (cacheState) {
                status = null;
            }
            else {
                this.failedDomains[domain] = this.failedDomains[domain] || {
                    time: Date.now(),
                    attempts: 0,
                    delay: 0,
                };
                if (this.failedDomains[domain].attempts >= this.maxAttempts) {
                    setTimeout(function () {
                        _this.backToLive(domain);
                    }, 50000);
                    // status = false // handle as final error
                }
                else if (this.failedDomains[domain].attempts < this.maxAttempts) {
                    this.failedDomains[domain].attempts++;
                    this.failedDomains[domain].delay = (this.failedDomains[domain].delay ? this.failedDomains[domain].delay * 2 : 2);
                    status = this.failedDomains[domain].delay; // call again by delay
                }
            }
        }
        if (status === undefined) {
            this.failedDomains[domain] = this.failedDomains[domain] || {
                time: Date.now(),
            };
            setTimeout(function () {
                _this.backToLive(domain);
            }, 120000);
            var failedDomainsKeys_1 = Object.keys(this.failedDomains);
            var list = this.backends[this.env][this.screenType][this.platform];
            var randArray = shuffle__default["default"](Object.values(list).filter(function (backDom) { return failedDomainsKeys_1.indexOf(backDom) === -1; }));
            if (randArray.length) {
                localStore.localStore.set('2nd_ab', randArray[0]);
                status = true;
            }
            else {
                status = false;
            }
        }
        return status;
    };
    return SecondLocation;
}());
var secondLocation = new SecondLocation();

exports.secondLocation = secondLocation;
